module.exports = __webpack_public_path__ + "static/media/snow-tire-installation-red.caf531b9.svg";